/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Select,
  Divider,
  Card,
} from "antd";
import { Row, Col, Space, Badge } from "antd";
import { SaveFilled, ReloadOutlined } from "@ant-design/icons";
import { ButtonBack } from "../../components/button";
import { ModalResetPassword } from "../../components/modal/user/modal-reset";
import { useLocation, useNavigate } from "react-router";
import OptionService from '../../service/Options.service';
import UserService from "../../service/User.service";

const userService = UserService();
const opservice = OptionService();
const from = "/user";

/* สุ่มรหัสผ่านแบบง่าย อ่านง่าย ไม่มีตัวอักษรที่สับสน (0/O/l/1)
   รูปแบบ ตัวอักษรเล็ก 4 ตัว + ตัวเลข 4 ตัว เช่น kdrm4827 */
const randomPassword = () => {
  const chars = "abcdefghjkmnpqrstuvwxyz";
  const nums = "23456789";
  let out = "";
  for (let i = 0; i < 4; i++)
    out += chars[Math.floor(Math.random() * chars.length)];
  for (let i = 0; i < 4; i++)
    out += nums[Math.floor(Math.random() * nums.length)];
  return out;
};
const UserManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openResetModal, setOpenResetModal] = useState(false);
  const [formDetail, setFormDetail] = useState({});
  const { config } = location.state || { config: null };
  const [userOption, setUserOption] = useState([]);

  const [form] = Form.useForm();
  // const [packageTypeOption, setPackageTypeOption] = useState([]);

  useEffect(() => {
    // setLoading(true);
    opservice.optionsUser().then((res) => {
      let { data } = res.data;
      setUserOption(data);
    });

    if (config?.action !== "create") {
      getsupData(config.code);
    } else {
      /* ผู้ใช้ใหม่ ระบบสุ่มรหัสผ่านให้เลย (ผู้ใช้จะถูกบังคับเปลี่ยนตอน login ครั้งแรก) */
      form.setFieldValue("password", randomPassword());
    }
    console.log(config);

    return () => {
      form.resetFields();
    };
  }, []);

  /* ค่าตำแหน่งเดิมใน DB เป็นตัวพิมพ์ใหญ่ (เช่น Sale, MD) แต่ตัวเลือกใหม่ใช้รหัสตัวเล็ก
     (sale, md) — จับคู่แบบไม่สนตัวพิมพ์ ให้ช่องเลือกแสดงชื่อตำแหน่งถูกต้อง */
  useEffect(() => {
    const cur = form.getFieldValue("type");
    if (!cur || !Array.isArray(userOption) || userOption.length === 0) return;
    const hit = userOption.find(
      (o) =>
        String(typeof o === "string" ? o : o?.value).toLowerCase() ===
        String(cur).toLowerCase()
    );
    const val = hit ? (typeof hit === "string" ? hit : hit.value) : null;
    if (val && val !== cur) form.setFieldValue("type", val);
  }, [userOption, formDetail]);
  const getsupData = (v) => {
    userService
      .get(v)
      .then(async (res) => {
        const { data } = res.data;

        const init = {
          ...data,
        };

        setFormDetail(init);
        form.setFieldsValue({ ...init });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation Product.");
      });
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const parm = { ...formDetail, ...v };
      const actions =
        config?.action !== "create"
          ? userService.update(parm)
          : userService.create(parm);
      actions
        .then(async (r) => {
          message.success("Request success.");
          navigate(from, { replace: true });
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "error request");
        });
    });
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "กรุณาใส่ชื่อผู้ใช้!" }]}
            label="Username"
          >
            <Input
              disabled={config.action === "edit"}
              size="small"
              placeholder="กรอก Username"
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={6}
          style={
            config.action === "create"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            name="password"
            rules={[
              {
                required: config.action === "create",
                message: "กรุณาใส่รหัสผ่าน!",
              },
            ]}
            label="Password"
          >
            <Input
              readOnly
              size="small"
              placeholder="ระบบสุ่มให้อัตโนมัติ"
              style={{ height: 40 }}
              addonAfter={
                <ReloadOutlined
                  title="สุ่มรหัสผ่านใหม่"
                  style={{ cursor: "pointer" }}
                  onClick={() => form.setFieldValue("password", randomPassword())}
                />
              }
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={8}
          lg={8}
          xl={6}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            rules={[{ required: true, message: "กรุณาใส่รหัสผ่าน!" }]}
            label="Password"
          >
            <Input.Password
              disabled={config.action === "edit"}
              size="small"
              defaultValue="12345678"
              style={{ height: 40 }}
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={4}
          lg={4}
          xl={4}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="รีเซ็ต Password">
            <Button
              style={{ width: 100 }}
              onClick={() => {
                setOpenResetModal(true);
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Col>
        <Divider></Divider>
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <Form.Item
            name="firstname"
            rules={[{ required: true, message: "กรุณาใส่ชื่อจริง!" }]}
            label="ชื่อจริง"
          >
            <Input placeholder="กรอกชื่อจริง" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <Form.Item
            name="lastname"
            rules={[{ required: true, message: "กรุณาใส่ชื่อนามสกุล!" }]}
            label="นามสกุล"
          >
            <Input placeholder="กรอกนามสกุล" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <Form.Item
            name="type"
            rules={[{ required: true, message: "กรุณาระบุประเภท!" }]}
            label="ตำแหน่ง"
          >
            <Select
              style={{ height: 40 }}
              placeholder="เลือกตำแหน่ง"
              /* API คืนเป็น {value,label} จากทะเบียนตำแหน่ง (ak_role)
                 เผื่อข้อมูลเก่าที่เป็นข้อความล้วนไว้ด้วย */
              options={(userOption || []).map((item) =>
                typeof item === "string"
                  ? { value: item, label: item }
                  : { value: item?.value, label: item?.label || item?.value }
              )}
              showSearch
              optionFilterProp="label"
              // <Select
              //   style={{ height: 40 }}
              //   placeholder="เลือกตำแหน่ง"
              //   options={[
              //     { value: "Admin", label: "Admin" },
              //     { value: "พนักงานขาย", label: "พนักงานขาย" },
              //     { value: "ธุรการ", label: "ธุรการ" },
              //     { value: "จัดซื้อ", label: "จัดซื้อ" },
              //     { value: "ช่าง", label: "ช่าง" },
              //     { value: "กรรมการ", label: "กรรมการ" },
              //     { value: "ผู้จัดการสาขา", label: "ผู้จัดการสาขา" },
              //   ]}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <Form.Item name="tel" label="เบอร์โทรศัพท์">
            <Input placeholder="กรอกเบอร์โทรศัพท์" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <Form.Item name="email" label="อีเมล">
            <Input placeholder="กรอกอีเมล" />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={6}
          style={
            config.action === "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "Y",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "N",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Form.Item name="code">
          <Input type="hidden" disabled />
        </Form.Item>
      </Row>
    </>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
          >
            บันทึก
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  return (
    <div className="xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        <Form form={form} layout="vertical">
          <Card title={config?.acname}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>

      {openResetModal && (
        <ModalResetPassword
          show={openResetModal}
          close={() => {
            setOpenResetModal(false);
          }}
          code={form.getFieldValue("code")}
        />
      )}
    </div>
  );
};

export default UserManage;
